import React, { useState } from "react";
import Dashboard from "./pages/Dashboard";
import Login from "./components/auth/Login";
import Profile from "./components/auth/Profile";
import "./App.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { colors } from "./utils/colors";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "./utils/queryClient";

import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

const theme = createTheme({
  palette: {
    primary: {
      main: colors.volvoBlue,
      light: colors.complementaryBlue,
      dark: colors.volvoBlue,
    },
    secondary: {
      main: colors.complementaryBlue,
    },
    success: {
      main: colors.success,
    },
    error: {
      main: colors.error,
    },
    warning: {
      main: colors.warning,
    },
    info: {
      main: colors.info,
    },
    background: {
      default: colors.background,
      paper: colors.cardBackground,
    },
    text: {
      primary: colors.primaryText,
      secondary: colors.secondaryText,
    },
  },
  typography: {
    fontFamily: "SigmaSans, sans-serif",
  },
});

export default function App(): React.JSX.Element {
  const [token, setToken] = useState<string | undefined>();
  const { isAuthenticated, isLoading } = useAuth0();

  if (isLoading) return <div>Loading...</div>;

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={
                isAuthenticated ? (
                  <Dashboard token={token} />
                ) : (
                  <Navigate to="/login" replace />
                )
              }
            />
            <Route path="/login" element={<Login setToken={setToken} />} />
            <Route
              path="/Profile"
              element={
                isAuthenticated ? <Profile /> : <Navigate to="/Login" replace />
              }
            />
          </Routes>
        </BrowserRouter>
        <ReactQueryDevtools initialIsOpen={false} />
      </ThemeProvider>
    </QueryClientProvider>
  );
}
